// Where an old "apply to this breakdown" link lands.
//
// /register/special/actor?bd=…&roleid=… is what the classic open-breakdown
// page and the login page (registerTrial) still send. With a breakdown on it
// the visitor wants to submit, so it enters the submission flow the way a role
// picked from the casting calls does: straight to step 1 when the link names a
// role, the breakdown's landing page (which lists its roles) when it doesn't.
// Step 1 and the landing page check the breakdown is still open themselves.
// Without a breakdown there is nothing to submit to, and the link stays with
// the classic signup (null).

import { buildFlowSearch, parseSubmissionParams } from "./submissionParams";

// Only the classic wizard reads these: `page=openbd` is the flag Routes.tsx
// used to add, `cwblabs` is stripped from every classic link too.
const CLASSIC_ONLY = ["page", "cwblabs"];

export const legacyBreakdownEntry = (
  search: string | undefined
): { pathname: string; search: string } | null => {
  const { bd, roleid } = parseSubmissionParams(search);
  if (!bd) return null;
  const params = new URLSearchParams(search || "");
  CLASSIC_ONLY.forEach((key) => params.delete(key));
  return {
    pathname: roleid ? "/submission/flow/step/1" : "/submission/boost",
    search: buildFlowSearch(params.toString(), bd, roleid),
  };
};
